import React from 'react';
import clsx from 'clsx';
import { FieldWrapper } from './FieldWrapper';

export const InputField = ({
  type = 'text',
  label,
  className,
  onChange,
  maxLength,
  caption,
  disabled,
  value,
  registration,
  placeholder,
  error,
  required,
}) => {
  return (
    <FieldWrapper label={label} error={error}>
      {caption && <div className="text-xs text-gray-500 mb-2">{caption}</div>}

      <input
        type={type}
        maxLength={maxLength}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        required={required}
        onChange={onChange}
        {...registration}
        className={clsx(
          'block w-full px-3 py-2 rounded-md text-sm bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-fundo-green-300 dark:focus:ring-fundo-green-600 focus:border-fundo-green-600 transition',
          className
        )}
      />
    </FieldWrapper>
  );
};
